import { lazy } from 'react'
import PublishRosterLoader from './publish/loader'
import EditRosterLoader from './edit/loader'
import RosterTemplatesLoader from './templates/loader'
import ManageRosterTemplatesLoader from './templates/manage/loader'
import RosterOverviewLoader from './overview/loader'
import CopyLoader from './copy/loader'

export default {
  Edit: {
    Component: lazy(() => import('./edit/EditRoster.Page')),
    Loader: EditRosterLoader,
  },
  Publish: {
    Component: lazy(() => import('./publish/PublishRoster.Page')),
    Loader: PublishRosterLoader,
  },
  Templates: {
    Component: lazy(() => import('./templates/RosterTemplates.Page')),
    Loader: RosterTemplatesLoader,
  },
  ManageRosterTemplates: {
    Component: lazy(
      () => import('./templates/manage/ManageRosterTemplates.Page')
    ),
    Loader: ManageRosterTemplatesLoader,
  },
  Overview: {
    Component: lazy(() => import('./overview/RosterOverview.Page')),
    Loader: RosterOverviewLoader,
  },
  Copy: {
    Component: lazy(() => import('./copy/CopyRoster.Page')),
    Loader: CopyLoader,
  },
}
